import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePortalAuth } from "../../context/PortalAuth";

export default function PortalProtectedRoute({ children }) {
  const { user, loading } = usePortalAuth();
  const location = useLocation();

  // While the OAuth callback is being processed, don't redirect.
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return children;
  }
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-[#eae7de] flex items-center justify-center gap-3 text-[#1e3d3a]/60 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" /> Loading your portal…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/portal/login" replace state={{ from: location }} />;
  }
  return children;
}
